import { Inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';

import { SessionService } from '@ridango/components';
import Env from '@ridango/core/env';

@Injectable()
export class PurchaseGuard implements CanActivate {
    constructor(
        private session: SessionService,
        private router: Router,
        private translate: TranslateService,
        @Inject('ENV') private env: Env
    ) {}

    canActivate() {
        if (!this.session.getLoginStatus() && this.env.PURCHASE?.DISABLE_UNAUTHORIZED_PURCHASE) {
            this.router.navigate([this.translate.currentLang, 'login']);
            return;
        }
        return true;
    }
}
